import React, { useEffect, useState } from 'react'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import ViewPage from '../../../Components/ViewPage'
import { Container } from './styles'
import { TabelaConsultoria } from './components/tabela'
import { useGetConsultoria, useGetConsultoriaEditar } from '../../../services/consultoria/GET'
import { FormConsultoria } from './components/gaveta'
import { destroyAlert, errorAlert, loadingAlert } from '../../../utils/alert'
import { buscaCidade, listUf } from '../../../services/Afins'
import { useGetCnpj } from '../../../services/buscarCNPJ'
import {
  postCadastroConsultoria,
  postCadastroConsultoriaEditar,
  usePostConsultoria,
} from '../../../services/consultoria/POST'
import { maskCNPJ } from '../../../utils'

const CadastroConsultoria: React.FC = () => {
  //TABELA
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState<number>(0)
  const [buscarTabela, setBuscarTabela] = useState('')
  const [openForm, setOpenForm] = useState<boolean>(false)
  const [update, setUpdate] = useState<number>(null)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //FORMULARIO
  const [logo, setLogo] = useState([])
  const [logoUrl, setLogoUrl] = useState('')
  const [nome, setNome] = useState<string>('')
  const [cpf_cnpj, setCpf_cnpj] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [celular, setCelular] = useState<string>('')
  const [telefone, setTelefone] = useState<string>('')
  const [cep, setCep] = useState<string>('')
  const [dataCity, setDataCity] = useState([])
  const [dataCidadeFilter, setDataCidadeFilter] = useState([])
  const [listUF, setListUF] = useState([])
  const [cidade, setCidade] = useState<string>('')
  const [cidadeId, setCidadeId] = useState<number>(0)
  const [estado, setEstado] = useState<string>('')
  const [estadoId, setEstadoId] = useState<number>(0)
  const [endereco, setEndereco] = useState<string>('')
  const [complemento, setComplemento] = useState<string>('')
  const [timeRenderizar, setTimeRenderizar] = useState(false)
  const [loading, setLoading] = useState(false)
    const [tipo_cliente, setTipo_cliente] = useState<string>('F')

  const { refetch_data_consultoria, carregando_consultoria, data_consultoria } = useGetConsultoria(
    pagination,
    page,
    buscarTabela
  )
  const {
    carregando_consultoria_editar,
    data_consultoria_editar,
    refetch_data_consultoria_editar,
  } = useGetConsultoriaEditar(update)
  // const { data_cnpj, refetch } = useGetCnpj(cpf_cnpj?.replace(/[^\d]/g, ''))

  async function listarEstados() {
    const resUF = await listUf()
    setListUF(resUF)
  }

  const handleChangeCidadeUf = async (cod) => {
    const cidadesFiltrar = dataCity.filter((item) => item.cod_uf === cod)
    setDataCidadeFilter(cidadesFiltrar)
    setLoading(false)
  }

  async function listarCidade() {
    const resCity = await buscaCidade('', '', '')
    setDataCity(resCity)
  }

  function abrirFormulario() {
    setOpenForm(true)
  }

  function editarFormulario(cod) {
    setOpenForm(true)
    setUpdate(cod)
  }

  function fecharGaveta() {
    setOpenForm(false)
    setUpdate(0)
    setNome('')
    setCpf_cnpj('')
    setEmail('')
    setCelular('')
    setTelefone('')
    setCep('')
    setCidade('')
    setCidadeId(0)
    setEndereco('')
    setComplemento('')
    setLogoUrl('')
    setLogo([])
    setEstado('')
    setEstadoId(0)
    refetch_data_consultoria()
  }

  async function salvarConsultoria() {
    const data = {
      nome: nome,
      cpf_cnpj: cpf_cnpj,
      email: email,
      fone: celular,
      fone2: telefone,
      cep: cep,
      cod_cidade: cidadeId,
      endereco: endereco,
      complemento: complemento,
      logo: logo?.[0]?.originFileObj,
    }

    if (update <= 0) {
      const response = await postCadastroConsultoria(data, fecharGaveta, setLoading)
    } else {
      const response = await postCadastroConsultoriaEditar(update, data, fecharGaveta, setLoading)
    }
  }

  function checkCep(cepValue) {
    loadingAlert({ msg: 'Buscando CEP...', id: 'cep' })
    setLoading(true)
    const cep = cepValue.replace(/\D/g, '')
    setTimeout(() => {
      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then((res) => res.json())
        .then((data) => {
          if (data.bairro !== '' && data.logradouro !== '') {
            setEndereco(data.logradouro)
            const estadoFiltrado = listUF?.filter((item) => item.nome === data?.estado)
            setEstado(data.estado)
            setEstadoId(estadoFiltrado[0]?.cod)
            const cidadeFiltrada = dataCity?.filter((rec) => rec.nome === data?.localidade)
            setCidadeId(cidadeFiltrada[0]?.cod)
            setCidade(data.localidade)
          } else {
            const estadoFiltrado = listUF?.filter((item) => item.nome === data?.estado)
            setEstado(data.estado)
            setEstadoId(estadoFiltrado[0]?.cod)
            const cidadeFiltrada = dataCity?.filter((rec) => rec.nome === data?.localidade)
            const cidadeFiltradaUF = cidadeFiltrada?.filter(
              (city) => city?.uf_nome === data?.estado
            )
            setCidadeId(cidadeFiltradaUF[0]?.cod)
            setCidade(data.localidade)
            setEndereco('')
            setComplemento('')
          }
        })
      destroyAlert('cep')
      setLoading(false)
    }, 300)
  }

  function verificarCpfCnpj(valor) {
    if (valor.length === 14) {
      return maskCNPJ(valor)
    }
  }

  useEffect(() => {
    if (cep?.length === 9 && timeRenderizar) {
      checkCep(cep)
    }
  }, [cep])

  useEffect(() => {
    refetch_data_consultoria()
    listarCidade()
    listarEstados()
  }, [])

  useEffect(() => {
    if (data_consultoria_editar?.itens?.length > 0) {
      const { nome, cpf_cnpj, email, fone, fone2, cep, cidade, endereco, complemento, logo_url } =
        data_consultoria_editar.itens[0]
      setNome(nome)
      setCpf_cnpj(cpf_cnpj)
      if (cpf_cnpj.length === 18) {
        setTipo_cliente('J')
      }else{
        setTipo_cliente('F')
      }
      setEmail(email)
      setCelular(fone)
      setTelefone(fone2)
      setCep(cep)
      handleChangeCidadeUf(cidade?.[0]?.cod_uf)
      setEstado(cidade?.[0]?.uf_nome)
      setEstadoId(cidade?.[0]?.cod_uf)
      setCidade(cidade?.[0]?.nome)
      setCidadeId(cidade?.[0]?.cod)
      setEndereco(endereco)
      setComplemento(complemento)
      setLogoUrl(logo_url)
    }
  }, [data_consultoria_editar])

  useEffect(() => {
    if (update > 0) {
      refetch_data_consultoria_editar()
    }
  }, [update])

  return (
    <Container>
      <ViewPage
        title='Consultoria'
        btnClick={null}
        newHide
        rotina={27}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Consultoria</TitleH1>
        </div>
        <TabelaConsultoria
          loading={carregando_consultoria}
          list_consultoria={data_consultoria?.itens}
          abrir={abrirFormulario}
          editar={editarFormulario}
          total={data_consultoria?.total}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
        />
        <FormConsultoria
          open={openForm}
          fecharGaveta={fecharGaveta}
          update={update}
          logo={logo}
          setLogo={setLogo}
          nome={nome}
          setNome={setNome}
          cpf_cnpj={cpf_cnpj}
          setCpf_cnpj={setCpf_cnpj}
          email={email}
          setEmail={setEmail}
          celular={celular}
          setCelular={setCelular}
          telefone={telefone}
          setTelefone={setTelefone}
          cep={cep}
          setCep={setCep}
          dataCity={dataCidadeFilter}
          dataUf={listUF}
          cidade={cidade}
          setCidade={setCidade}
          setCidadeId={setCidadeId}
          estado={estado}
          setEstado={setEstado}
          setEstadoId={setEstadoId}
          endereco={endereco}
          setEndereco={setEndereco}
          complemento={complemento}
          setComplemento={setComplemento}
          timeRenderizar={timeRenderizar}
          setTimeRenderizar={setTimeRenderizar}
          salvarConsultoria={salvarConsultoria}
          loading={loading}
          carregando={carregando_consultoria_editar}
          logoUrl={logoUrl}
          handleChangeCidadeUf={handleChangeCidadeUf}
          tipo_cliente={tipo_cliente}
          setTipo_cliente={setTipo_cliente}
        />
      </ViewPage>
    </Container>
  )
}

export default CadastroConsultoria
